<template>
  <span v-if="$slots.default" @click="showModal">
    <slot></slot>
  </span>
  <a-modal
    v-model:visible="visible"
    :centered="true"
    :maskClosable="false"
    width="1200px"
    :title="row?.materialNo + row?.materialName + '库存单价变化'"
    @ok="handleOk"
  >
    <table-wrapper
      :row-key="'uuid'"
      :dataSource="dataSource"
      :columns="columns"
      :showCheckbox="false"
      :showTooTip="false"
      :maxHeight="DEFAULTTABLEMAXHEIGHT"
      :tableHeight="600"
      :pagination="pagination"
      :loading="wareLoading"
      @onTableChange="onTableChange"
    >
    </table-wrapper>
    <template #footer>
      <a-button type="primary" @click="handleOk">关闭</a-button>
    </template>
  </a-modal>
</template>

<script lang="ts" setup>
import { PropType, defineProps, ref, defineEmits } from "vue";
import { TeamService } from "@/views/project/team/team.service";
import { DEFAULTCOUNTMAX, DEFAULTPRICELENGTH, DEFAULTTABLEMAXHEIGHT } from "@/core/constant";
import { message } from "ant-design-vue";
import { columns } from "./constant";
import { WarehouseService } from "@/views/material/manage/manage.service";
import { PaginationReq } from "@/core";
const props = defineProps({
  row: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
});
const {
  run: runWarehouse,
  loading: wareLoading,
  pagination: pagination,
  data:dataSource
} = WarehouseService.usePricePageApi();
const emits = defineEmits(["refresh"]);
const visible = ref(false);
const params= new PaginationReq()
const showModal = async () => {
  await search()
  visible.value = true;
};
const search=async () => {
  params.current=1;
  params['materialId']=props.row.materialId
  params['repertotyId']=props.row.repertotyId
  
  await runWarehouse(params);
}
const handleOk = () => {
  visible.value = false;
};
const onTableChange=async(e)=>{
  params.current = e.current;
  params.size = e.pageSize;
  params['materialId']=props.row.materialId
  await runWarehouse(params);
}
</script>
